import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import { TeamsIcon } from '@atlaskit/temp-nav-app-icons/teams';
import {
	LinkMenuItem,
	type LinkMenuItemProps,
} from '@atlaskit/navigation-system/side-nav-items/link-menu-item';
import { useNavigateToTeamsApp } from '@confluence/teams-app-config';

const i18n = defineMessages({
	TeamsAppShortcutName: {
		id: 'side-navigation.custom.teams-app-shortcut.name',
		description: 'name to custom teams app shortcut link',
		defaultMessage: 'Teams',
	},
});

const elemBefore: LinkMenuItemProps['elemBefore'] = <TeamsIcon size="20" />;
const elemAfter: LinkMenuItemProps['elemAfter'] = (
	<LinkExternalIcon label="" spacing="spacious" size="small" />
);

export function TeamsAppShortcutItem() {
	const { href } = useNavigateToTeamsApp({
		type: 'LANDING',
	});

	return (
		<LinkMenuItem elemAfter={elemAfter} elemBefore={elemBefore} href={href} target="_blank">
			<FormattedMessage {...i18n.TeamsAppShortcutName} />
		</LinkMenuItem>
	);
}
